export default __webpack_public_path__ + "static/Disappearing Chip-ca1dd8d9857113de8129da234ff31437.png";